import interfaces from '../interface/index'
import request from '@/request/index.js'
// import cryptoRequest from '@/request/cryptoRequest'
import qs from 'qs'
const user = {
  queryBanner (params) {
    return request.get(`${interfaces.queryBanner}`, {
      params: params
    })
  },
  queryCategory (params) {
    return request.get(`${interfaces.queryCategory}`, {
      params: params
    })
  },
  queryHome (params) {
    return request.get(`${interfaces.queryHome}`, {
      params: params
    })
  },
  queryCategoryVideos (params) {
    return request.get(`${interfaces.queryCategoryVideos}`, {
      params: params
    })
  },
  queryVideoByCategoryId (params) {
    return request.get(`${interfaces.queryVideoByCategoryId}`, {
      params: params
    })
  },
  queryVideoList (params) {
    return request.get(`${interfaces.queryVideo}`, {
      params: params
    })
  },
  queryQa (params) {
    return request.get(`${interfaces.queryQa}`, {
      params: params
    })
  },
  settingRingOnePointMon (data) {
    return request.post(`${interfaces.settingRingOnePointMon}`, qs.stringify(data))
  },
  getOrderList (params) {
    return request.get(`${interfaces.getOrderList}`, {
      params: params
    })
  },
  qyrSubedProducts (params) {
    return request.get(`${interfaces.qrySubedProducts}`, {
      params: params
    })
  },
  unSubProductWithVCode (data) {
    return request.post(`${interfaces.unSubProductWithVCode}`, qs.stringify(data))
  },
  // delOrder (data) {
  //   return request.post(`${interfaces.delOrder}`, qs.stringify(data))
  // },
  // sendVerifyCode (params) {
  //   return request.get(`${interfaces.sendVerifyCode}`, {
  //     params: params
  //   })
  // },
  // addtoneFree (data) {
  //   return request.post(`${interfaces.addtoneFree}`, qs.stringify(data))
  // },
  // checkMobile (params) {
  //   return request.get(`${interfaces.checkMobile}`, {
  //     params: params
  //   })
  // },
  // ringStatus (params) {
  //   return request.get(`${interfaces.ringStatus}`, {
  //     params: params
  //   })
  // },
  // monthStatusV1 (params) {
  //   return request.get(`${interfaces.monthStatusV1}`, {
  //     params: params
  //   })
  // },
  // mobileRingOpen (data) {
  //   return request.post(`${interfaces.mobileRingOpen}`, qs.stringify(data))
  // },
  // monthStatusV2 (params) {
  //   return request.get(`${interfaces.monthStatusV2}`, {
  //     params: params
  //   })
  // },
  // toneFreeOrderV1 (data) {
  //   return request.post(`${interfaces.toneFreeOrderV1}`, qs.stringify(data))
  // },
  // toneFreeOrderV2 (data) {
  //   return request.post(`${interfaces.toneFreeOrderV2}`, qs.stringify(data))
  // },
  // ringCallBack (data) {
  //   return request.post(`${interfaces.ringCallBack}`, qs.stringify(data))
  // },
  // queryIntroduce (params) {
  //   return request.get(`${interfaces.queryIntroduce}`, {
  //     params: params
  //   })
  // },
  // // 根据id获取彩铃的视频
  // searchDetailById (params) {
  //   return request.get(`${interfaces.searchDetailById}`, {
  //     params: params
  //   })
  // },
  // // 根据歌曲、歌手推荐获取相关视频
  // searchRel (params) {
  //   return request.get(`${interfaces.searchRel}`, {
  //     params: params
  //   })
  // },
  // 渠道记录
  channelAdd (data) {
    return request.post(`${interfaces.channeladd}`, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  // bw订购记录
  actionlogApi (data) {
    return request.post(`${interfaces.actionlog}`, qs.stringify(data))
  }
  // // 查看配置提示语
  // queryConfig () {
  //   return request.get(`${interfaces.queryConfig}`, {})
  // }
  // // 查看配置提示语
  // queryRule () {
  //   return request.get(`${interfaces.queryRule}`, {})
  // }
  // 查看配置提示语
  // queryProcessConfig () {
  //   return request.get(`${interfaces.queryConfig}`, {})
  // },
  // queryTopicDraft (params) {
  //   return request.get(`${interfaces.queryTopicDraft}`, {
  //     params: params
  //   })
  // },
  // queryTopic (params) {
  //   return request.get(`${interfaces.queryTopic}`, {
  //     params: params
  //   })
  // },

  // queryRingRel (params) {
  //   return request.get(`${interfaces.queryRingRel}`, {
  //     params: params
  //   })
  // }
}

export default user
